import React from 'react';
import { SectionTag } from './SectionTag';
const FUNCTIONS = [{
  part: 'Tu perfil',
  role: 'genera confianza.'
}, {
  part: 'Tu contenido',
  role: 'demuestra valor.'
}, {
  part: 'Tus Stories',
  role: 'generan conexión.'
}, {
  part: 'Tus Reels',
  role: 'aumentan alcance.'
}, {
  part: 'Tus conversaciones',
  role: 'convierten interés en turnos.'
}, {
  part: 'Tu calendario',
  role: 'mantiene todo funcionando sin improvisar.'
}];
export function SolutionSection() {
  return <section className="bg-blush py-12 sm:py-16" data-id="element-177" data-mp="3t8dh08gic9wk">
      <div className="mx-auto max-w-4xl px-5" data-id="element-178" data-mp="3t7vl5cxrbxp6">
        <div className="text-center" data-id="element-179" data-mp="aue57uuvkqjm">
          <SectionTag data-id="element-180" data-mp="atcn56ffz3se">El sistema</SectionTag>
          <h2 className="mt-3 font-display text-2xl font-black leading-tight text-ink sm:text-4xl" data-id="element-181" data-mp="aw8hkks2zac3">
            Un sistema para que cada parte de tu Instagram tenga una función.
          </h2>
        </div>

        <ul className="mt-8 grid gap-2.5 sm:grid-cols-2" data-id="element-182" data-mp="fth40xk9i0j5">
          {FUNCTIONS.map(f => <li key={f.part} className="rounded-xl border border-rose/10 bg-white px-4 py-3.5 text-sm leading-snug shadow-sm" data-id="element-183" data-mp="frnwzh5qleam">
              <span className="font-semibold text-ink" data-id="element-184" data-mp="3ba8meab1d4jm">{f.part}</span>{' '}
              <span className="text-ink/70" data-id="element-185" data-mp="3fa91zy9vfls9">{f.role}</span>
            </li>)}
        </ul>

        <p className="mt-7 text-center font-display text-xl font-bold text-rose-deep sm:text-2xl" data-id="element-186" data-mp="3kbg8zv46wgxv">
          Eso es Estética Digital PRO.
        </p>
      </div>
    </section>;
}